import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButton, type ActionButtonGroup } from '../ActionButton/ActionButton';

export interface DrawerFooterProps {
  actions: ActionButtonGroup[];
  /** Label for the action button trigger. Defaults to translated "Actions". */
  buttonLabel?: string;
}

export const DrawerFooter: React.FC<DrawerFooterProps> = ({ actions, buttonLabel }) => {
  const { t } = useTranslation('c-main');

  const visibleActions = useMemo(
    () => actions.filter(a => !a.hide),
    [actions],
  );

  if (visibleActions.length === 0) return null;

  return (
    <div className="px-4 py-3 border-t shrink-0">
      <ActionButton
        actions={actions}
        buttonLabel={buttonLabel ?? t('actions', { defaultValue: 'Actions' })}
      />
    </div>
  );
};
